import React, { useContext, useEffect, useState } from "react";
import "./Colaboradores.css";
import { Button, Col, Row } from "antd";
import axios from "axios";
import * as links from "../../../../utils/links";
import { AuthContext } from "../../../../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { format, parseISO } from "date-fns";
import { SERVIDOR_URL } from "../../../../utils/constants";

const Colaboradores = (props) => {
  const { setDataUser, authInfo, setNotiMessage } = useContext<any>(AuthContext);
  const { dataUser } = authInfo;
  let navigate = useNavigate();

  const token = authInfo?.dataUser?.token;

  const [totalClientes, setTotalClientes] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<any>(true);

  useEffect(() => {
    dataData();
  }, []);

  const dataData = () => {
    if (!dataUser?.id || !token) {
      setIsLoading(false);
      navigate(links.SIGNIN, { replace: true });
      return;
    }
    setIsLoading(true);
    axios.get(`${SERVIDOR_URL}/colaboradores/${dataUser.id}`, {
      headers: {
        "x-access-token": token,
        "content-type": "application/json",
      },
    }).then((res) => {
      if (res.status === 200) {
        setIsLoading(false);
        setTotalClientes(res.data);
      } else {
        throw new Error();
      }
    }).catch((err) => {
      setIsLoading(false);
      if ([401, 403].includes(err.response?.status)) {
        setNotiMessage('A sua sessão expirou, para continuar faça login novamente.');
        setNotiMessage({
          type: "error",
          message:
            "A sua sessão expirou, para continuar faça login novamente.",
        });
        if (dataUser?.key === 'ADMIN') {
          navigate(links.ADMIN_SIGNIN)
          setDataUser(null);
        } else {
          navigate(links.SIGNIN)
          setDataUser(null);
        }
      }
    });
  };

  const handleClienteClick = ({
    id,
    nome,
    cpf,
    status,
    dataInclusao,
    ultimoAcesso,
    permissao,
    valorCortesia
  }) => {
    const cliente = {
      id,
      nome,
      cpf,
      status,
      dataInclusao,
      ultimoAcesso,
      permissao,
      valorCortesia
    };
    navigate(`${links.PAGAMENTOS_COLABORADOR}/${id}`, {
      state: cliente,
    });
  };

  return (
    <div>
      {isLoading && <LoadingAction />}
      <div className="Cliente_WarningMsgSpan">
        <span>{dataUser?.warningMsg}</span>
      </div>
      <div className="Cliente_Dashboard_header">
        <div className="Cliente_Dashboard_staBlockTitle">Colaboradores</div>
      </div>
      <div className="Cliente_Dashboard_action">
        <Button style={{ margin: "0 15px" }} onClick={dataData}>
          <FontAwesomeIcon
            icon={faArrowsRotate}
            style={{ marginRight: "5px" }}
          />
          Atualizar
        </Button>
        <Link to={links.ADD_COLABORADOR}>
          <Button className="Cliente_Dashboard_addbtn">
            <AiOutlinePlusCircle />
            <span>Criar novo colaborador</span>
          </Button>
        </Link>
      </div>

      <Row>
        {totalClientes.map((post) => {
          return (
            <Col
              xs={24}
              md={20}
              lg={20}
              xl={20}
              className="Cliente_Dashboard_col"
            >
              <div
                className="Cliente"
                key={post.id}
                onClick={() =>
                  handleClienteClick({
                    id: post.id,
                    nome: post.nome,
                    cpf: post.cpf,
                    status: post.status,
                    dataInclusao: post.dataInclusao,
                    ultimoAcesso: post.ultimoAcesso,
                    permissao:post.permissao,
                    valorCortesia:post.valorCortesia
                  })
                }
              >
                <div className="Cliente-info">
                  <div>
                    <h3>{post.nome}</h3>
                    <div className="Cliente-email">{post.email}</div>
                    <div className="Cliente-maquina">
                      CPF: {post.cpf}
                    </div>
                  </div>
                  <div className="Cliente-type-info">
                    <div className="Cliente-type-title">
                      <div>Situação:</div>
                    </div>
                    <div>
                      <div
                        className="Cliente-type-val"
                        style={{
                          color: post.status === 'ATIVO' ? "green" : "red",
                        }}
                      >
                        {post.status}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="Cliente-footer">
                  <div>
                    Data de Inclusão:{" "}
                    {format(new Date(post.dataInclusao), "dd/MM/yyyy - kk:mm")}
                  </div>
                  <div>
                    Último Acesso:{" "}
                    {post.ultimoAcesso
                      ? format(
                        new Date(post.ultimoAcesso),
                        "dd/MM/yyyy - kk:mm"
                      )
                      : "--"}
                  </div>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default Colaboradores;
